module.exports = __webpack_public_path__ + "img/afghanistan-logo-icon.69fe8d90.png";